const scoreEditTicheng = () =>
  import('@/views/main/score/commission/edit/edit.vue')
export default {
  path: '/main/score/scoreEditTicheng',
  name: 'scoreEditTicheng',
  component: scoreEditTicheng,
  children: []
}
